import { useQuery } from "@tanstack/react-query";
import adminApiClient, { PlanChoiceStats } from "api/admin";

export default function usePlanChoiceStats() {
  return useQuery<PlanChoiceStats>({
    queryKey: ["planChoiceStats"],
    queryFn: () => adminApiClient.getPlanChoiceStats(),
  });
}
